<template>
  <div class="flex justify-between items-start mb-2">
    <h2 class="text-base">
      <slot>{{ title }}</slot>
    </h2>
    <button
      class="text-grey text-xs"
      @click="$emit('toggle')"
      v-text="toggleText"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    showingCode: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    toggleText() {
      return this.showingCode ? 'Show Grid' : 'Show Code';
    },
  },
};
</script>
